import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VueCircle from 'vue2-circle-progress';

@Component({
  name: 'bpc-page-title',
  components: {
    VueCircle,
  },
})
export default class PageTitle extends Vue {
  @Prop(String) heading: string;
  @Prop(String) subheading: string;
  @Prop(Object) actions: Record<string, any>;
  @Prop(Array) selection: any[];
  @Prop(String) view: string;
  @Prop({ type: Boolean, default: false }) readonly showBackButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showTitle: boolean;
  @Prop({ type: Boolean, default: true }) readonly hiddeWhenPrint: boolean;

  public fill = { gradient: ['var(--primary)'] };
  public fill1 = { gradient: ['#2af598', '#009efd'] };
  public fill2 = { gradient: ['#fccb90', '#d57eeb'] };

  public positions = ['left', 'bulk', 'middle', 'right'];

  clickOnAction($event: string) {
    this.$emit('click-on-action', $event);
  }

  public getActionsByTag(tag: string) {
    const actions = {};
    if (this.actions) {
      for (const key of Object.entries(this.actions)) {
        if (this.actions[key[0]].tag == tag) {
          actions[key[0]] = this.actions[key[0]];
        }
      }
    }
    return actions;
  }

  routeBack() {
    this.$router.go(-1);
  }

  /* Lifecycle hooks */

  // created() { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
